/**
 * Connections follow the project scope (cards 5.1–5.4), pure. Owner decision
 * 0.3: show ALL connections, the project's own on top.
 *
 * A connection is in a project by the project's `contains` link to its graph
 * node — `ssh_host:<id>` (SFTP / FTP and Terminal SSH share these vault
 * items) or `db_connection:<id>`. A team row's id is `team:<teamId>:<itemId>`,
 * so its node is `ssh_host:team:<teamId>:<itemId>`. Nothing is ever written
 * into a vault item (the security rule in hooks/useConnectionRows.js).
 *
 *   All projects   one ungrouped list, in the given order
 *   a project      [the project's connections] then [the others]
 *   No project     [connections in no project] then [the rest]
 */
import { ALL_PROJECTS, normalizeScopeId, splitByProject } from './projectScopeFilter';

export const KIND_SSH = 'ssh_host';
export const KIND_DB = 'db_connection';

export const connectionNodeId = (kind, row) => `${kind}:${row?.id}`;

/** The connection's own scope: a team vault row is its team's, everything else personal. */
export const connectionWireScope = (row) => (row?.origin === 'team' && row.teamId != null ? `team:${row.teamId}` : 'personal');

/** Temp ("this session only") rows are never project members: they are gone on restart. */
export const canJoinProject = (row) => Boolean(row) && row.origin !== 'temp';

/**
 * `{ grouped, top, others }` — `grouped` is false under All projects (then
 * every row is in `others`, untouched order).
 */
export function groupConnections(rows = [], scope = {}, kind = KIND_SSH) {
  if (normalizeScopeId(scope.activeProjectId) === ALL_PROJECTS) return { grouped: false, top: [], others: rows };
  const { inProject, others } = splitByProject(rows, scope, (row) => ({ nodeId: connectionNodeId(kind, row) }));
  return { grouped: true, top: inProject, others };
}

/** Ids in `next` that were not in `prev` (a just-saved connection). */
export function newIds(prev = [], next = []) {
  const seen = new Set(prev.map(String));
  return next.map(String).filter((id) => !seen.has(id));
}
